import React from 'react';
import { Container } from 'styles/pages/edit-products/editProductDialog';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { StyledDialog } from 'pages/groups/style';

const SyncProductDialog = ({ open, setModal }) => (
  <StyledDialog
    open={open}
    onClose={() => setModal(false)}
    maxWidth='sm'
    style={{ width: '100%' }}>
    <Container>
      <CheckCircleIcon
        style={{
          color: 'green',
          display: 'block',
          margin: '10px auto',
          fontSize: 80,
        }}
      />
      <h1 style={{ textAlign: 'center' }}>Product Syncing complete.</h1>
    </Container>
  </StyledDialog>
);

export default SyncProductDialog;
